// extracted by mini-css-extract-plugin
export default {"clt_27_47":"styles_clt_27_47__P+HXH"};